import * as React from "react";
import styled from "styled-components";
import { useContext, useCallback, useEffect } from "react";
import { FormGroup, ControlLabel, HelpBlock } from "components/bootstrap";
import ViewsQueryInput from "views/components/searchbar/ViewsQueryInput";
import QueryValidationDisplay from "views/components/searchbar/queryvalidation/QueryValidationDisplay";
import FormWarningsContext from "contexts/FormWarningsContext";
import validateQuery from "views/components/searchbar/queryvalidation/validateQuery";
import useUserDateTime from "hooks/useUserDateTime";
const noOpValidate = () => Promise.resolve({});
const noOpExecute = () => {
};
const HELP_TEXT = "Optional query to filter source messages. Leave blank to use all messages.";
const InputRow = styled.div`
  display: flex;
  align-items: center;
`;
const toTimeRange = (from) => ({
  type: "relative",
  from: from / 1e3
});
const AnomalyQueryInput = ({ controlId, value, onChange, streams, eventDefinition }) => {
  const { setFieldWarning, warnings } = useContext(FormWarningsContext);
  const validationState = warnings == null ? void 0 : warnings.queryString;
  const { userTimezone } = useUserDateTime();
  const validateQueryString = useCallback(
    (queryString, streamIds, timeRange, timezone) => {
      const request = {
        timeRange,
        queryString,
        streams: streamIds
      };
      validateQuery(request, timezone).then((result) => {
        if ((result == null ? void 0 : result.status) === "WARNING" || (result == null ? void 0 : result.status) === "ERROR") {
          setFieldWarning("queryString", result);
        } else {
          setFieldWarning("queryString", void 0);
        }
      });
    },
    [setFieldWarning]
  );
  useEffect(() => {
    validateQueryString(
      value,
      eventDefinition.config.streams,
      toTimeRange(eventDefinition.config.search_within_ms),
      userTimezone
    );
  }, [
    value,
    eventDefinition.config.streams,
    eventDefinition.config.search_within_ms,
    setFieldWarning,
    userTimezone,
    validateQueryString
  ]);
  return /* @__PURE__ */ React.createElement(FormGroup, { controlId }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Search Query ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")), /* @__PURE__ */ React.createElement(InputRow, null, /* @__PURE__ */ React.createElement(
    ViewsQueryInput,
    {
      value,
      onChange,
      name: "query",
      inputId: controlId,
      placeholder: HELP_TEXT,
      streams,
      isValidating: false,
      validate: noOpValidate,
      onExecute: noOpExecute,
      error: (validationState == null ? void 0 : validationState.status) === "ERROR" ? validationState : void 0,
      warning: (validationState == null ? void 0 : validationState.status) === "WARNING" ? validationState : void 0
    }
  ), /* @__PURE__ */ React.createElement(QueryValidationDisplay, null)), /* @__PURE__ */ React.createElement(HelpBlock, null, HELP_TEXT));
};
export default AnomalyQueryInput;
